import { render, staticRenderFns } from "./CustomStudy.vue?vue&type=template&id=a5baeb5c&scoped=true"
import script from "./CustomStudy.vue?vue&type=script&lang=js"
export * from "./CustomStudy.vue?vue&type=script&lang=js"
import style0 from "./CustomStudy.vue?vue&type=style&index=0&id=a5baeb5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5baeb5c",
  null
  
)

export default component.exports